import type { IForgotPasswordLocale } from '../../../../../Pages/Onboard/Forgot/Locale/ForgotPassword.locale';

const esES: IForgotPasswordLocale = {
  title: '¿Olvidaste tu contraseña?',
  subtitle:
    '¡No hay problema! Ingresa el correo asociado a tu cuenta y te enviaremos un enlace para restablecer tu contraseña.',
  email: {
    label: 'Correo electrónico',
    placeholder: 'Ingresa tu dirección de correo electrónico',
    error: 'Por favor, ingresa una dirección de correo electrónico válida',
  },
  button: {
    sendLink: 'Enviar Enlace de Restablecimiento',
    backToLogin: 'Volver al Login',
    sendingLink: 'Enviando...',
  },
  success: {
    title: 'Revisa tu correo electrónico',
    message:
      'Hemos enviado un enlace de restablecimiento de contraseña. Revisa tu bandeja de entrada y sigue las instrucciones para restablecer tu contraseña.',
  },
};

export { esES };
